import { UnifiedGraftModelType } from '@graftcode/protocol'

export const isStaticMethodType = (type: string | number): boolean => {
  const typeString = String(type)
  const typeNumber = typeof type === 'number' ? type : undefined

  return (
    typeString === 'STATIC_METHOD' ||
    typeString === 'OVERLOADED_STATIC_METHOD' ||
    typeString === 'GLOBAL_METHOD' ||
    typeString === 'OVERLOADED_GLOBAL_METHOD' ||
    typeNumber === UnifiedGraftModelType.STATIC_METHOD ||
    typeNumber === UnifiedGraftModelType.OVERLOADED_STATIC_METHOD ||
    typeNumber === UnifiedGraftModelType.GLOBAL_METHOD ||
    typeNumber === UnifiedGraftModelType.OVERLOADED_GLOBAL_METHOD
  )
}
